module.exports = __webpack_public_path__ + "img/inside.cb89fc2e.png";